import type { State } from './vuex.d';
import type { GetGettersState } from '@/typings/vuex.d';

export default {
  totalCourseCount(state: State): number {
    return state.courses.length;
  },

  courseFilterPayload(state: State): Record<string, unknown> {
    const filters: Record<string, unknown> = {};

    if (state.filters.queryString.length > 0) {
      filters.queryString = state.filters.queryString;
    }

    if (state.filters.statuses.some(option => option.selected)) {
      filters.status = state.filters.statuses.filter(option => option.selected).map(option => option.key);
    }

    if (state.filters.courseTypes.some(option => option.selected)) {
      filters.courseType = state.filters.courseTypes.filter(option => option.selected).map(option => option.key);
    }

    return filters;
  },

  hasFiltersEnabled(state: State, getters: GetGettersState<typeof this>): boolean {
    return Object.keys(getters.courseFilterPayload).length > 0;
  },
};
